<template>
  <div>
    <div v-if="item.type === DISCOUNT_AMOUNT_TYPE.PERCENT">
      {{ convertPrice(item.value) }}
      {{ DISCOUNT_AMOUNT_TYPE_NAME[item.type] }}
      <span v-text="'Tối đa: '" class="font-weight-bold" />
      <span v-text="convertPrice(item.maxValue)" class="text-warning" />
      <div>
        <i class="fa-solid fa-circle-arrow-right"></i>
        {{ convertPrice(item.voucherValue) }}
      </div>
    </div>
    <div v-else>
      {{ convertPrice(item.voucherValue) }}
    </div>
    <div class="d-flex justify-content-end">
      <VoucherCumulativeValue
        v-if="item.cumluativeValues && item.cumluativeValues.length"
        :cumluativeValues="item.cumluativeValues"
      />
    </div>
  </div>
</template>

<script>
import { convertPrice } from '@/utils/common';
import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name';
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
import VoucherCumulativeValue from '@/view/components/voucher/VoucherCumulativeValue.vue';

/**
 * Ô "Giá trị" của voucher. Tách ra vì cửa sổ chọn voucher dựng nó ở hai chỗ:
 * bảng trong từng nhóm gập mở và bảng phẳng lúc tìm kiếm.
 */
export default {
  components: { VoucherCumulativeValue },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { DISCOUNT_AMOUNT_TYPE_NAME, DISCOUNT_AMOUNT_TYPE };
  },
  methods: { convertPrice },
};
</script>
